import { useEffect, useState } from "react";
import axios from "axios";
import { PoundSterling, Clapperboard, FileText } from "lucide-react";
import ValuationFollowUpBuilder from "@/ValuationFollowUpBuilder";
import ValuationVideoBuilder from "@/ValuationVideoBuilder";
import { useAuth } from "./AuthContext";
import { AppHeader } from "./AppHeader";
import "./ValuationFollowUp.css";
import "./ValuationVideo.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Post Valuation tile — two tools:
 *  • Post Valuation Video (Synthesia avatar video, triggered per branch)
 *  • Follow-Up Script (existing AI covering note / long-format script)
 */
export default function ValuationTools({ onBack }) {
  const { user } = useAuth();
  const [mode, setMode] = useState("video");
  const [settings, setSettings] = useState({
    agent_name: user?.name || "",
    agency_name: user?.branch_name || "",
    agency_style: "Friendly & Conversational",
  });

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/admin/my-script-settings`);
        setSettings((prev) => ({
          agent_name: r.data?.agent_name || prev.agent_name,
          agency_name: r.data?.agency_name || prev.agency_name,
          agency_style: r.data?.agency_style || prev.agency_style,
        }));
      } catch (_) {
        /* fall back to defaults */
      }
    })();
  }, []);

  return (
    <div className="App" data-testid="valuation-tools-page">
      <div className="container">
        <AppHeader onBack={onBack} />

        <div className="vt-page-header" data-testid="vt-page-header">
          <div className="vt-page-header-icon">
            <PoundSterling size={22} />
          </div>
          <div className="vt-page-header-text">
            <h1 className="vt-page-title" data-testid="valuation-tools-title">
              Post Valuation
              <span className="vt-free-badge" data-testid="valuation-tools-free-badge">
                Free
              </span>
            </h1>
            <p className="vt-page-sub">
              Follow up every market appraisal with a personal video or script —
              free for every NicheCom client.
            </p>
          </div>
        </div>

        <div className="vt-mode-toggle" data-testid="vt-mode-toggle">
          <button
            className={`vt-mode-btn ${mode === "video" ? "mode-active" : ""}`}
            onClick={() => setMode("video")}
            data-testid="vt-mode-video"
          >
            <Clapperboard size={16} />
            Post Valuation Video
            <span className="vt-mode-new">NEW</span>
          </button>
          <button
            className={`vt-mode-btn ${mode === "script" ? "mode-active" : ""}`}
            onClick={() => setMode("script")}
            data-testid="vt-mode-script"
          >
            <FileText size={16} />
            Follow-Up Script
          </button>
        </div>

        {mode === "video" ? (
          <ValuationVideoBuilder agentName={settings.agent_name} agencyName={settings.agency_name} />
        ) : (
          <ValuationFollowUpBuilder
            agentName={settings.agent_name}
            agencyName={settings.agency_name}
            agencyStyle={settings.agency_style}
          />
        )}
      </div>
    </div>
  );
}
